export default "__VITE_ASSET__Co2eLP24__"